import React from "react";
import type { InputProps } from "reactstrap/lib/Input";
import { FormRenderer, type IFormRendererProps } from "./FormRenderer";
import { DatePickerRenderer } from "src/shared/forms/inputs/DatePickerRenderer";

export type IDateRendererProps = IFormRendererProps &
  InputProps & {
    options: Map<string, string>;
  };

export const DateRenderer = ({
  input,
  meta,
  label,
  ...rest
}: IDateRendererProps) => {
  const { error, submitting } = meta;

  return (
    <FormRenderer input={input} meta={meta} label={label}>
      <DatePickerRenderer
        input={input}
        {...rest}
        invalid={!!error}
        disabled={rest.disabled || submitting}
      />
    </FormRenderer>
  );
};
